import getCorePersonalStore from "../../../../../stores/core/core-personal-store";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import UserAddComments from "./UserAddComments";
import UserCommentsTable from "./UserCommentsTable";

const UserCommentsBox = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();

  return isAnyKhattabaAdmin ? null : (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={1500}
      height={25}
      fDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{
        borderRadius: 30 * unitX
      }}
      onClick={() => { }}
    >
      <UserAddComments />
      <UserCommentsTable />
    </ET3Div>
  );
});
export default UserCommentsBox;
